// extracted by mini-css-extract-plugin
export default {"imagePlaceholder":"_1apxS","image":"LnPDR","animatedBackground":"_1zTrc","placeHolderShimmer":"_3h8Lm"};